import React, {useEffect, useState} from "react";
import {Dropdown} from "@mui/base/Dropdown";
import {MenuButton} from "@mui/base/MenuButton";
import {Menu} from "@mui/base/Menu";
import {MenuItem} from "@mui/base/MenuItem";
import CircularProgress from '@mui/material/CircularProgress';

const thumbsContainer = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "8px",
    marginTop: "12px",
};

const thumb = {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center", // Added this to center content vertically
    borderRadius: "8px",
    border: "2px solid #d1d5db", // Tailwind's gray-300
    padding: "8px 12px",
    backgroundColor: "#f9fafb", // Tailwind's gray-50
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
    height: "58px",
    maxWidth: "250px",
};

const thumbImg = {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    borderRadius: "8px",
    border: "2px solid #d1d5db", // Tailwind's gray-300
    backgroundColor: "#f9fafb", // Tailwind's gray-50
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
    width: "58px",
    height: "58px",
};

const thumbTitle = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: "0.875rem", // Tailwind's text-sm
    fontWeight: "500",    // Tailwind's font-medium
    color: "#4b5563",     // Tailwind's gray-700
    marginBottom: "4px",
};

const fileTypeLabel = {
    fontSize: "12px",
    color: "#6b7280",    // Tailwind's gray-500
};

const iconStyle = {
    fontSize: "1.5rem",
    display: "flex",      // Added to better center the icon
    alignItems: "center", // Added to better center the icon
    justifyContent: "center", // Added to better center the icon
    marginBottom: "4px",
};

const fileInfoContainer = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center", // This centers items vertically
    justifyContent: "space-between",
    height: "100%", // Changed from fixed height to use full available height
    gap: "16px",
};

const fileInfoContainerImg = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "58px",
    height: "58px",
};

const fileInfoContainer_2 = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center", // Changed from flex-start to center
};

const closeButton = {
    position: "absolute",
    top: "-5px",
    right: "-5px",
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    border: "2px solid #d1d5db", // Tailwind's gray-300
    background: "white",
    fontSize: "16px",
    fontWeight: "bold",
    color: "#6b7280",
    cursor: "pointer",
    padding: "0",
    lineHeight: "1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};

const img = {
    display: "block",
    width: "100%",
    height: "100%",
    borderRadius: "8px",
};

const img_pdf = {
    display: "block",
    width: "30px",
    height: "38px",
    margin: "0 auto", // Added to center the PDF icon horizontally
};

// Utility function to get file type label and icon
const getFileTypeInfo = (file) => {
    const mimeType = file.type;

    if (mimeType.startsWith('image/')) {
        return {label: 'Image', icon: file.preview}; // Replace with actual icon component
    } else if (mimeType === 'application/pdf') {
        return {label: 'PDF', icon: "/document-pdf.svg"}; // Replace with actual icon component
    } else if (
        mimeType === 'application/msword' ||
        mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ) {
        return {label: 'Document', icon: '📝'}; // Replace with actual icon component
    } else {
        return {label: 'File', icon: '📁'}; // Replace with actual icon component
    }
};

function AttachmentContainer({files, setFiles, isViewingUsedFiles = false}) {
    if (isViewingUsedFiles) {
        files = files.flat();
    }
    const handleRemove = (file, index) => {
        const updatedFiles = files.filter((_, i) => !(i === index && _.name === file.name));
        setFiles(updatedFiles);
    };

    const thumbs = files?.map((file, index) => {
        const {label, icon} = getFileTypeInfo(file);

        const isLoading = file.loading;

        return (
            <div key={index} style={file.type.startsWith("image") ? thumbImg : thumb}>
                {!isViewingUsedFiles && (
                    <button
                        onClick={() => handleRemove(file, index)}
                        style={closeButton}
                        aria-label="Remove file"
                    >
                        ×
                    </button>
                )}
                <div style={file.type.startsWith("image") ? fileInfoContainerImg : fileInfoContainer}>
                    <div style={iconStyle}>
                        <img
                            src={icon}
                            style={file.type.startsWith("image") ? img : img_pdf}
                            alt={file.name}
                        />
                        {isLoading && (
                            <div style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                backgroundColor: 'rgba(255,255,255,0.6)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '8px',
                            }}>
                                <CircularProgress size={24} />
                            </div>
                        )}
                    </div>
                    {!file.type.startsWith("image") && (
                        <div style={fileInfoContainer_2}>
                            <span style={thumbTitle}>
                                {file.name.length > 20 ? file.name.substring(0, 18) + "..." : file.name}
                            </span>
                            <span style={fileTypeLabel}>{label}</span>
                        </div>
                    )}
                </div>
            </div>
        );
    });

    return (
        <section className="attachment-container">
            <aside style={thumbsContainer}>
                {thumbs}
            </aside>
        </section>
    );
}

export {AttachmentContainer};